import stylesheet from './SuccessStoryCard.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import {NXTOverlay} from "../../parts/Overlay/Overlay";

class NXTSuccessStoryCard extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get backdrop(): string {
        return this.getAttribute('backdrop') ?? 'backdrop-opacity-black-low';
    }

    get overlay(): NXTOverlay | undefined {
        return this.getSlotElements('overlay')[0] as NXTOverlay;
    }

    render() {
        const card = document.createElement('div');
        card.classList.add('success-story', this.backdrop);
        if(this.parentElement.classList.contains('success-story-cards')) {
            card.classList.add('in-success-story-list');
        }
        card.innerHTML = `
            <div class="background"></div>
            <div class="body">
                <div class="top">
                    <slot name="tag"></slot>
                </div>
                <div class="bottom">
                    <div class="title"></div>
                    <div class="text-row">
                        <div class="text"></div>
                    </div>
                </div>
            </div>
            <slot name="overlay"></slot>
        `;
        this.cloneSlotContentIntoContainer(card.querySelector('.title'), 'title');
        this.cloneSlotContentIntoContainer(card.querySelector('.background'), 'background');
        this.preventImgDraggable(card.querySelector('.background'));
        this.cloneDefaultSlotContentIntoContainer(card.querySelector('.text'));
        card.addEventListener('click', () => {
            this.openOverlay();
            window.dispatchEvent(new CustomEvent('init3QPlayers'));
        });
        return card;
    }

    openOverlay() {
        this.overlay?.open();
    }

    preventImgDraggable(container: HTMLElement) {
        container.querySelectorAll('img').forEach(img => {
            img.setAttribute('draggable', 'false');
        });
    }

}

customElements.define('nxt-success-story-card', NXTSuccessStoryCard);
